/* ============
 * popular product
 * ============
 *
 * This is horizontal bar.
 */
import { mapGetters } from 'vuex';
import userWidgetsService from './../../../services/widgets';
import LineChart from './../../widgetsChart/line/line.vue';

export default {
  components: {
    LineChart,
  },

  data() {
    return {
      lineColor: ['#3B82F6', '#10B981', '#F59E0B', '#8B5CF6', '#EF4444'],
      options: {
        plugins: {
          datalabels: {
            display: false,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 0, right: 0, top: 0, bottom: 0,
          },
        },
        legend: {
          display: true,
          position: 'left',
          labels: {
            boxWidth: 4,
            fontColor: '#64748B',
          },
        },
        scales: {
          xAxes: [{
            gridLines: { color: '#E5E7EB', zeroLineColor: '#E5E7EB' },
            ticks: { fontColor: '#94A3B8', fontSize: 11 },
          }],
          yAxes: [{
            gridLines: { color: '#E5E7EB', zeroLineColor: '#E5E7EB' },
            ticks: { fontColor: '#94A3B8', fontSize: 11 },
          }],
        },
        tooltips: {
          enabled: true,
          backgroundColor: '#1e293b',
          titleFontColor: '#fff',
          bodyFontColor: '#94A3B8',
          callbacks: {
            label: ((tooltipItem, data) => `${data.datasets[tooltipItem.datasetIndex].tooltip} - ${tooltipItem.yLabel}`),
          },
        },
      },
      chartdata: {
        labels: [],
        datasets: [],
      },
      loaded: false,
      filterBy: [
        { label: this.$t('static.widgets.soldProduct.filters.last3Months'), value: 'last_3_months' },
        { label: this.$t('static.widgets.soldProduct.filters.last6Months'), value: 'last_6_months' },
        { label: this.$t('static.widgets.soldProduct.filters.thisYear'), value: 'this_year' },
      ],
      filterBySelected: 'last_3_months',
      monthNumber: 3,
      monthStart: 1,
    };
  },

  computed: {
    ...mapGetters({
      popularProductsWidgets: 'popularProductsWidgets',
    }),
  },

  methods: {
    updateChart(value) {
      this.monthStart = 1;
      if (value === 'last_3_months') {
        this.monthNumber = 3;
      } else if (value === 'last_6_months') {
        this.monthNumber = 6;
      } else {
        this.monthStart = 0;
        this.monthNumber = parseInt(new Date().getMonth());
      }
      this.initializeWidgets(value);
    },

    popularProd(popularProdWidgets) {
      const self = this;
      const tempData = [];
      const tempData2 = [];
      const tempData5 = [];
      const tempDataLabels = [];
      this.chartdata.labels = [];
      this.chartdata.datasets = [];

      /** Assign the filter by months */
      this.getFilterBy(this.monthNumber).forEach((item) => {
        tempData5[new Date(Date.parse(`${item} 1, 2020`)).getMonth() + 1] = item;
      });

      this.chartdata.labels = [];
      tempData5.forEach((item) => { tempDataLabels.push(item); });
      tempDataLabels.forEach((item) => { tempData2[item] = 0; });

      /** Looping the products, it contains product name and total count*/
      popularProdWidgets.top.forEach((item, key) => {
        const tempData3 = [];
        const tempData4 = [];

        /** This will reset the count of every product */
        for (let i = 0; i <= self.monthNumber; i++) {
          tempData2[self.getFilterBy(self.monthNumber)[i]] = 0;
        }

        popularProdWidgets.data.forEach((item2) => {
          if (item.name === item2.name) tempData2[item2.month] += 1;
        });

        /** This will add to object */
        tempData3.push(tempData2);
        const values = Object.entries(tempData3[0]);
        for (const value of values) { tempData4.push(value[1]); }

        if (tempData4.length > 0) {
          tempData.push({
            tooltip: item.name,
            label: (item.name.length <= 9) ? item.name : `${item.name.substring(0, 6)}...`,
            borderColor: self.lineColor[key],
            backgroundColor: self.colorOpacity(self.lineColor[key], 0.5),
            data: tempData4,
          });
        }
      });

      this.chartdata = {
        labels: tempDataLabels.map(m => this.toNorwegianMonth(m)),
        datasets: tempData,
      };

      this.loaded = true;
    },

    initializeWidgets(filter) {
      this.loaded = false;
      Promise.all([
        userWidgetsService.fetchPopularProductsWidgets(filter),
      ]).then(() => {
        this.popularProd(this.popularProductsWidgets.items);
      });
    },

    toNorwegianMonth(englishMonth) {
      const date = new Date(Date.parse(`${englishMonth} 1, 2020`));
      return date.toLocaleDateString('nb-NO', { month: 'long' });
    },

    getFilterBy(value) {
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December',
      ];

      const today = new Date();
      const filterBy = [];

      for (let i = this.monthStart; i <= value; i++) {
        let month = (today.getMonth() - i);
        if (month <= 0) {
          month += 12;
        }
        filterBy.push(monthNames[month]);
      }
      return filterBy;
    },

    colorOpacity(color, opacity) {
      const opacityy = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
      return color + opacityy.toString(16).toUpperCase();
    },

    onResize() {
      if (window.innerWidth <= 1270) {
        this.options = this.chartOptions('top', 8);
      } else {
        this.options = this.chartOptions('left', 4);
      }
      if (this.loaded === true) {
        this.initializeWidgets(this.filterBySelected);
      }
    },

    chartOptions(legendPos = 'left', lengendBoxWidth = 4) {
      return {
        plugins: {
          datalabels: { display: false },
        },
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: { left: 0, right: 0, top: 0, bottom: 0 },
        },
        legend: {
          display: true,
          position: legendPos,
          labels: { boxWidth: lengendBoxWidth, fontColor: '#64748B' },
        },
        scales: {
          xAxes: [{
            gridLines: { color: '#E5E7EB', zeroLineColor: '#E5E7EB' },
            ticks: { fontColor: '#94A3B8', fontSize: 11 },
          }],
          yAxes: [{
            gridLines: { color: '#E5E7EB', zeroLineColor: '#E5E7EB' },
            ticks: { fontColor: '#94A3B8', fontSize: 11 },
          }],
        },
        tooltips: {
          enabled: true,
          backgroundColor: '#1e293b',
          titleFontColor: '#fff',
          bodyFontColor: '#94A3B8',
          callbacks: {
            label: ((tooltipItem, data) => `${data.datasets[tooltipItem.datasetIndex].tooltip} - ${tooltipItem.yLabel}`),
          },
        },
      };
    },
  },

  created() {
    window.addEventListener('resize', this.onResize);
    this.initializeWidgets();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
};



// WEBPACK FOOTER //
// ./src/app/components/widgets/popularProducts/popularProducts.js